/**
 * @param {string|URL|Readonly<URL>} url
 * @returns {TDomainData|boolean}
 */
window.parseDomain = (url) => {
	if (typeof url === 'string') {
		try {
			url = new URL(url);
		} catch (e) {
			return false;
		}
	}
	if (!(url instanceof URL)) {
		return false;
	}

	const hostname = url.hostname.replace(/^www\./, '');
	const domainParts = hostname.split('.');
	const domain = domainParts.slice(-2).join('.');
	const subdomain = domainParts.slice(0, -2).join('.');

	return { hostname, domain, subdomain };
};

/**
 * @param {*} link
 * @returns {string|*}
 */
const makeLinkRelative = (link) =>
	typeof link === 'string'
		? link.replace(/^(https?:)?\/\/[^/]+(\/?.*)/i, '$2')
		: link;

const baseDomain = `${location.protocol}//${document.domain}`;

const currentHref = makeLinkRelative(decodeURIComponent(location.href));

window.currentUrl = Object.freeze(new URL(currentHref, baseDomain));

window.currentDomainData = Object.freeze(parseDomain(window.currentUrl));

const isHofProd = Object.freeze(currentDomainData.domain === 'houseoffun.com');

window.isHofProd = isHofProd;

/**
 * @param {string} src
 * @returns {Element}
 */
const createScript = (src) => {
	const script = document.createElement('script');
	script.src = src;
	script.type = 'text/javascript';
	script.charset = 'UTF-8';
	script.async = true;

	return script;
};

// Load the OneTrust AutoBlock script and the Optanon SDK
(() => {
	const id = isHofProd
		? '12a2d55e-d610-4432-8d8f-8381fddd56b9'
		: '12a2d55e-d610-4432-8d8f-8381fddd56b9-test';

	const qtAutoBlock = createScript(
		`https://cdn.cookielaw.org/consent/${id}/OtAutoBlock.js`
	);

	const sdk = createScript(
		'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
	);

	sdk.setAttribute('data-domain-script', id);

	const firstScript = document.getElementsByTagName('script')[0];

	firstScript.parentNode.insertBefore(qtAutoBlock, firstScript);
	firstScript.parentNode.insertBefore(sdk, firstScript);
})();

window.OptanonWrapper = () => {};

// placeholder for the ga function
window.ga = () => {};

window.ga.getAll = () => [];

// placeholder for the fbq function
window.fbq = () => {};

(() => {
	window.interdeal = {
		sitekey: isHofProd
			? 'b07dd69b8f111c6c48ad263fc9537dce'
			: 'bdebadd0413ff08b0313bed42d116c2d',
		Position: 'Left',
		Menulang: 'EN',

		domains: isHofProd
			? {
					js: 'https://js.nagich.co.il/',
					acc: 'https://access.nagich.co.il/',
				}
			: {
					js: 'https://cdn.equalweb.com/',
					acc: 'https://access.equalweb.com/',
				},

		btnStyle: isHofProd
			? {
					color: {
						main: '#111231',
						second: '#ffffff',
					},
					vPosition: ['85%', '15%'],
					scale: ['0.6', '0.5'],
					icon: {
						type: 6,
						shape: 'circle',
						outline: false,
					},
				}
			: {
					vPosition: ['80%', null],
					scale: ['0.6', '0.6'],
					icon: {
						type: 6,
						shape: 'circle',
						outline: true,
					},
				},
	};

	const accessibilityScript = document.createElement('script');

	accessibilityScript.src = isHofProd
		? 'https://js.nagich.co.il/core/4.3.5/accessibility.js'
		: 'https://cdn.equalweb.com/core/4.3.5/accessibility.js';
	accessibilityScript.defer = true;
	accessibilityScript.integrity =
		'sha512-30Chwp4k6gvr11Nui4Sw5tDn1GV6CmQCpEe6dfCT8s9Mj7vVhno2pu5hUPsR86QVFmqLEohG9h2wYw+rCVSWwQ==';
	accessibilityScript.crossOrigin = 'anonymous';
	accessibilityScript.setAttribute('data-cfasync', true);

	(document.body || document.head).appendChild(accessibilityScript);
})();
